import React from 'react'
import { numberWithCommas, dateTime } from '$Deposits/lib/LibCommonData'
import { DepositHeader } from '../index'
import UploadFile from '../Components/UploadFile'
import CopyView from '../Components/CopyView'
import DatePicker from '../Components/DatePicker'
import Modal from '../Components/Modal';
import TipsView from '../Components/TipsView'
import NextStepCon from '$Deposits/Components/LB/NextStep'
import moment from 'moment'
import CountdownTipsView from '../Components/CountdownTipsView';

class NextStep extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentDidMount() {

    }
    componentWillUnmount() {

    }

    render() {

        return (
            <>
                <NextStepCon
                    ModalCancel={(propCon) => {
                        const { modalVisible, modes, title, cancelText, okText, onCancel, onOk, msg } = propCon
                        return (
                            <Modal
                                className='modalTips'
                                visible={modalVisible}
                                header={false}
                                onlyOkBtn={false}
                                cancelText={cancelText}
                                okText={okText}
                                onCancel={onCancel}
                                onOk={onOk}
                            >
                                <>
                                    <div className='titleIcon'>
                                        <span className={`warningIcon imgIcon`} />
                                    </div>
                                    <p className="intro">{msg}</p>
                                </>
                            </Modal>
                        )
                    }}
                    ModalUniqueAmt={(propCon) => {
                        const { modalVisible, title, msg, onChange, okText, cancelText} = propCon
                        return (
                            <Modal
                                className='modalTips'
                                visible={modalVisible}
                                title={title}
                                okText={okText}
                                onlyOkBtn={true}
                                onOk={onChange}
                                cancelText={cancelText}
                            >
                                <>
                                    <p className="intro intro_left">{msg}</p>
                                </>
                            </Modal>
                        )
                    }}
                    // 无法存款提示
                    Modal={(propCon) => {
                        const { modalVisible, title, msg, onChange, okText, cancelText, header} = propCon
                        return (
                            <Modal
                                className='modalTips'
                                visible={modalVisible}
                                title={title}
                                okText={okText}
                                header={header}
                                onlyOkBtn={true}
                                onOk={onChange}
                                cancelText={cancelText}
                            >
                                <>
                                    <div className='titleIcon'>
                                        <span className='warningIcon imgIcon' />
                                    </div>
                                    <p className="intro">{msg}</p>
                                </>
                            </Modal>
                        )
                    }}
                    NextStep={(propCon) => {
                        const {
                            DepositBankActive,
                            MethodsActive,
                            backClick,
                            onChange,
                            onCancel,
                            money,
                            LivechatClick,
                            MethodCodeActive,
                            DepositPayments,
                            DepositAccountByAmount,
                            setting,
                            showDate,
                            DepositTimer,
                            DepositMisc,
                            onCountdownFinish,
                            DepositTimeSelect,
                        } = propCon

                        let { accountHolderName, accountNo, bankName, submittedAt } = DepositAccountByAmount || DepositBankActive || {}
                        let moenyAmount = money
                        let submittedAts = submittedAt
                        const isSubmitEnabled = MethodCodeActive == 'UniqueAmt' || (DepositTimeSelect && DepositTimeSelect !== 'NOT_SET')

                        if (MethodCodeActive == 'UniqueAmt') {
                            //UniqueAmt渠道
                            const { uniqueAmount, amount, returnedBankDetails = {}, submittedAt } = DepositPayments || {}
                            moenyAmount = uniqueAmount || amount || ' '
                        }

                        return (
                            <div className='nextModal'>
                                <div className='nextModalCenter'>
                                    <div className='viewArea lbViewArea'>
                                        <CountdownTipsView DepositTimer={DepositTimer} onCountdownFinish={onCountdownFinish}  />
                                        <div className='depositInfo'>
                                            <CopyView
                                                copyTitle={'ยอดฝาก'}
                                                copyValue={numberWithCommas(moenyAmount)}
                                                copyType={'money'}
                                            />
                                            <CopyView
                                                copyTitle={'ธนาคาร'}
                                                copyValue={bankName}
                                                copyType={'bankName'}
                                            />
                                            <CopyView
                                                copyTitle={'เลขที่บัญชี'}
                                                copyValue={accountNo}
                                                copyType={'accountNo'}
                                            />
                                            <CopyView
                                                copyTitle={'ชื่อบัญชี'}
                                                copyValue={accountHolderName}
                                                copyType={'accountHolderName'}
                                            />
                                        </div>

                                        <div className={`depositOptions ${showDate ? "showDate" : ""}`}>
                                            {
                                                showDate &&
                                                <div className='DatePickerolumn'>
                                                    <div>
                                                        {/* 日期选择 */}
                                                        <p className='inputTitle'>วันที่ฝาก</p>
                                                        <DatePicker
                                                            mode={'date'}
                                                            titleText={'วันที่ฝาก'}
                                                        />
                                                    </div>
                                                    <div>
                                                        {/* 时间选择 */}
                                                        <div className='inputTitle'>
                                                            <p data-CN="存款時間">เวลาที่ฝาก</p>
                                                            <span className="required-label">จำเป็นต้องกรอก</span>
                                                        </div>
                                                        <DatePicker
                                                            mode={'time'}
                                                            titleText={'เวลาฝาก'}
                                                        />
                                                    </div>
                                                </div>
                                            }
                                            {/* 上传图片 */}
                                            <div>
                                                <UploadFile />
                                            </div>
                                            <div className='whiteTip'>
                                                หากคุณไม่สามารถอัปโหลดหลักฐานการฝากเงินกรุณาติดต่อฝ่ายบริการลูกค้าที่<br />
                                                <span onClick={LivechatClick}>ห้องช่วยเหลือสด</span>
                                            </div>
                                        </div>

                                        <div
                                            className={isSubmitEnabled ? 'submitBtnActive' : 'submitBtnDisabled'}
                                            onClick={isSubmitEnabled ? onChange : undefined}
                                        >
                                            โอนเงินมาเรียบร้อย
                                        </div>
                                        <div
                                            className='submitBorderActive'
                                            onClick={onCancel}
                                        >
                                            ยกเลิกการฝาก
                                        </div>
                                        <div className='remarks'>
                                            <p>การแจ้งเตือน：</p>
                                            <ol>
                                                <li>
                                                    โปรดตรวจสอบให้แน่ใจว่าคุณฝากเงินเข้าบัญชีธนาคารที่ถูกต้องจากทาง เรามิฉะนั้นการปรับอาจมีการล่าช้า
                                                </li>
                                                <li>
                                                    หลังจากการฝากเงินเสร็จสิ้นให้คลิกปุ่ม [โอนเงินมาเรียบร้อยแล้ว]<br />
                                                    และรอดำเนินการ กรุณาอย่าส่งหลายครั้งเพื่อการปรับที่ไว
                                                </li>
                                            </ol>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    }}

                />


            </>
        );
    }
}

export default NextStep

